<template>
    <div class="content-wrapper">
        <app-page-top-section :title="$t('all_employees')" icon="briefcase">
            <app-default-button btn-class="btn btn-success mr-2"
                :title="$fieldTitle('add', 'employee', true)"
                @click="isEmployeeCreateOpenModalActive = true"
                v-if="$can('add_employees')"
            />
            <div class="dropdown d-inline-block">
                <button type="button"
                        class="btn btn-primary dropdown-toggle"
                        data-toggle="dropdown"
                        aria-haspopup="true"
                        aria-expanded="false">
                    {{ $t('action') }}
                    <app-icon name="chevron-down"/>
                </button>
                <div class="dropdown-menu dropdown-menu-right">
                    <a href="#" class="dropdown-item"
                       v-if="$can('invite_employees')"
                       @click.prevent="isModalActive = true">
                        {{ $fieldTitle('invite', 'employee', true) }}
                    </a>
                    <a href="#" class="dropdown-item"
                       v-if="$can('import_attendances')"
                       @click.prevent="isImportModalActive = true">
                        {{ $t('import') }}
                    </a>
                    <a href="#" class="dropdown-item"
                       @click.prevent="requestAllProfileUpdate">
                        {{ $t('require_all_profile_update') }}
                    </a>
                    <a v-if="$can('view_employee_tag')"
                       href="/employee/tags"
                       class="dropdown-item">
                        {{ $t('employee_tags') }}
                    </a>
                </div>
            </div>
        </app-page-top-section>

        <app-table
            id="employee-table"
            :options="options"
            :card-view="true"
            @getRows="getSelectedRows"
            @action="triggerActions"
        />

        <app-employee-invite
            v-if="isModalActive"
            v-model="isModalActive"
            :selected-url="selectedUrl"
        />

        <employee-create-edit-model
            v-if="isEmployeeCreateOpenModalActive "
            v-model="isEmployeeCreateOpenModalActive"
            :selected-url="''"
        />

        <app-confirmation-modal
            :title="promptTitle"
            :message="promptMessage"
            :modal-class="modalClass"
            :icon="promptIcon"
            v-if="confirmationModalActive"
            modal-id="app-confirmation-modal"
            @confirmed="triggerConfirm"
            @cancelled="cancelled"
            :loading="loading"
            :self-close="false"
        />

        <app-employment-status-modal
            v-if="employmentStatusModalActive"
            v-model="employmentStatusModalActive"
            :id="employeeId"
        />

        <app-employee-termination-reason-modal
            v-if="isTerminationReasonModalActive"
            v-model="isTerminationReasonModalActive"
            :id="employeeId"
        />

        <app-employee-termination-modal
            v-if="isTerminateModalActive"
            v-model="isTerminateModalActive"
            :id="employeeId"
        />

        <employee-context-menu
            v-if="isContextMenuOpen"
            :employees="selectedEmployees"
            @close="isContextMenuOpen = false"
        />

        <app-attendance-create-edit-modal
            v-if="attendanceModalActive"
            v-model="attendanceModalActive"
            :employee="employee"
        />

        <app-leave-create-edit-modal
            v-if="leaveModalActive"
            v-model="leaveModalActive"
            :employee="employee"
        />

        <job-history-edit-modal
            v-if="isJobHistoryEditModalActive"
            v-model="isJobHistoryEditModalActive"
            :modalType="modalAction"
            :employee="employee"
            @reload="reloadEmployeeTable"
        />

        <employee-import-modal
            v-if="isImportModalActive"
            v-model="isImportModalActive"
            @import-complete="handleImportComplete"
        />

    </div>
</template>

<script>
import EmployeeMixin from "../../Mixins/EmployeeMixin";
import EmployeeContextMenu from "./Components/EmployeeContextMenu";
import JobHistoryEditModal from "./Components/JobHistory/components/JobHistoryEditModal";
import EmployeeImportModal from "./EmployeeImportModal";
import {axiosGet, axiosPatch} from "../../../../common/Helper/AxiosHelper";
import EmployeeCreateEditModel from "./EmployeeCreateEditModal"
import {EMPLOYEES} from "../../../Config/ApiUrl";

export default {
    components: {EmployeeContextMenu, JobHistoryEditModal, EmployeeCreateEditModel, EmployeeImportModal},
    mixins    : [EmployeeMixin],
    data() {
        return {
            isImportModalActive: false,
        };
    },
    mounted() {
        this.getSalaryRange();
        this.$hub.$on('open-termination-reason-modal', () => {
            this.isTerminationReasonModalActive = true;
        })
    },
    methods: {
        getSalaryRange() {
            axiosGet(this.apiUrl.SALARY_RANGE).then(({data}) => {
                let salaryFilter      = this.options.filters.find(item => item.key === 'salary');
                salaryFilter.maxRange = data.max_salary;
                salaryFilter.minRange = data.min_salary < data.max_salary ? data.min_salary : 0;
            })
        },
        requestAllProfileUpdate() {
            this.confirmationModalActive = true;
            this.promptAction = 'require_all_profile_update';
            this.promptTitle = this.$t('are_you_sure');
            this.promptMessage = this.$t('confirm_require_all_profile_update');
            this.promptIcon = 'alert-circle';
            this.modalClass = 'warning';
        },
        executeRequireAllProfileUpdate() {
            this.loading = true;
            axiosPatch(`${EMPLOYEES}/require-all-profile-update`).then(({data}) => {
                this.$toastr.s('', data.message);
                this.$hub.$emit('reload-employee-table');
            }).catch(({response}) => {
                this.$toastr.e('', response?.data?.message || 'Error');
            }).finally(() => this.closeConfirmation());
        },
        handleImportComplete() {
            this.isImportModalActive = false;
            this.$hub.$emit('reload-employee-table');
        }
    }
}
</script>
